function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m11.25 20h-9c-1.24 0-2.25-1.01-2.25-2.25v-8.5c0-1.24 1.01-2.25 2.25-2.25h11.5c1.24 0 2.25 1.01 2.25 2.25v3c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-3c0-.413-.337-.75-.75-.75h-11.5c-.413 0-.75.337-.75.75v8.5c0 .413.337.75.75.75h9c.414 0 .75.336.75.75s-.336.75-.75.75z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m12.25 8.5c-.414 0-.75-.336-.75-.75v-2.75c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5v2.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-2.75c0-2.757 2.243-5 5-5s5 2.243 5 5v2.75c0 .414-.336.75-.75.75z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m23.25 18h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.25v-1.25c0-.414.336-.75.75-.75s.75.336.75.75v2c0 .414-.336.75-.75.75z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m14.75 23.5c-.414 0-.75-.336-.75-.75v-2c0-.414.336-.75.75-.75h2c.414 0 .75.336.75.75s-.336.75-.75.75h-1.25v1.25c0 .414-.336.75-.75.75z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m14.94 18.5c-.072 0-.146-.011-.218-.032-.396-.121-.62-.54-.5-.936.643-2.113 2.563-3.532 4.778-3.532 1.85 0 3.537 1.015 4.403 2.648.193.366.054.82-.312 1.015-.369.191-.82.054-1.015-.312-.603-1.142-1.783-1.851-3.076-1.851-1.55 0-2.893.992-3.342 2.468-.098.324-.396.532-.718.532z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m19 24c-1.85 0-3.537-1.015-4.403-2.648-.193-.366-.054-.82.312-1.015.368-.192.82-.054 1.015.312.603 1.142 1.783 1.851 3.076 1.851 1.541 0 2.885-.993 3.344-2.473.123-.395.542-.617.938-.493.396.122.616.543.493.938-.654 2.11-2.573 3.528-4.775 3.528z"
});

var SvgPassword = function SvgPassword(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "_x31__x2C_5",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password.65987437.svg";
export { ForwardRef as ReactComponent };